import { TwinDictionary } from '../../globals/dictionary'
import useTwinTranslation from '../useTwinTranslation'

const useDictDays = () => {
    const { t } = useTwinTranslation()
    const days: TwinDictionary = {
        '0': { field: 'sunday', name: t('sunday', 'Domingo') },
        '1': { field: 'monday', name: t('monday', 'Lunes') },
        '2': { field: 'tuesday', name: t('tuesday', 'Martes') },
        '3': { field: 'wednesday', name: t('wednesday', 'Miércoles') },
        '4': { field: 'thursday', name: t('thursday', 'Jueves') },
        '5': { field: 'friday', name: t('friday', 'Viernes') },
        '6': { field: 'saturday', name: t('saturday', 'Sábado') },
    }
    return { days }
}

export default useDictDays